import { FC } from "react";

import { Space, Typography } from "antd";

import { StyledErrorBoundaryFallback } from "components/ErrorBoundaryFallback/styles";

export const MissingPage: FC = () => {
  return (
    <StyledErrorBoundaryFallback
      status="404"
      title="Oops! You've gone off the grid."
      subTitle={
        <Space direction="vertical">
          <Typography.Text type="secondary" strong>
            This page took a detour, but no need to file a missing package report. Try the homepage or check the address
            — no tracking number required.
          </Typography.Text>
        </Space>
      }
    />
  );
};
